import { SYSTEM_LANGUAGE_LABELS } from "../../shared/enums/shared-enums";
import { Work } from "../../types/work";

export const formatStringArray = (
  value: unknown,
  fallback = "N/A"
): string =>
  Array.isArray(value) && value.length > 0
    ? value.filter(Boolean).join("\n")
    : fallback;

export const formatSystemLanguage = (
  value: unknown,
  fallback = "N/A"
): string =>
  value &&
  typeof value === "string" &&
  value in SYSTEM_LANGUAGE_LABELS
    ? SYSTEM_LANGUAGE_LABELS[value as Work["system_language_type"]]
    : fallback;

export const formatDoxographicalCategory = (
  value: unknown,
  fallback = "N/A"
): string => {
  if (typeof value === "string") return value || fallback;
  return fallback;
};
